import { create } from 'zustand';

type Plans = {
  data: any[];
  setPlansData: (data: any[]) => void;
};

export const usePlansDataStore = create<Plans>((set, get) => ({
  data: [],
  setPlansData: data => set(() => ({ data: data })),
  action: () => {
    const data = get().data;
    // ...
  },
}));
